import React from 'react';
import LockSharpIcon from '@mui/icons-material/LockSharp';
import { COLOR_RED_LIGHT } from 'src/const';
import { Box, Grid, Typography } from '@mui/material';

const CenterPointer = ({
  lat,
  lng,
  CustomIcon,
  listingId,
  revenueLtm,
  isSelected,
  isHovered,
  setCurrentListingHovered,
  isMobileView
}: {
  lat: number;
  lng: number;
  CustomIcon?: any;
  listingId?: string;
  revenueLtm?: number | string;
  isSelected?: boolean;
  isHovered?: boolean;
  setCurrentListingHovered?: React.Dispatch<React.SetStateAction<string>>;
  isMobileView?: boolean;
}) => {
  const style = { color: COLOR_RED_LIGHT, fontSize: '32px', transform: 'translate(-50%,-50%)' };
  const styleListing = {
    background: 'white',
    padding: '5px 10px',
    borderRadius: '900px',
    transform: 'translate(-50%,-50%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 2px 4px #0004, 0 2px 10px #0002',
  };

  if (CustomIcon) {
    return (
      <div>
        <CustomIcon sx={style} />
      </div>
    );
  }

  if (!isSelected) {
    return <Box sx={{ ...styleListing }}></Box>;
  }

  if (isSelected && !revenueLtm) {
    return (
      <Box
      sx={{
        ...styleListing,
        width: '40px',
        ...(isHovered ? { background: 'black', color: 'white' } : {}),
      }}
    >
      <LockSharpIcon sx={{ color: isHovered? 'white' : 'black', fontSize: '18px' }} />
    </Box>
    );
  }

  if (isSelected && revenueLtm) {
    return (
      <Box
        sx={{
          ...styleListing,
          width: '80px',
          ...(isHovered ? { background: 'black', color: 'white' } : {}),
        }}
        onClick={() => {
          if(listingId && isMobileView){ 
            setCurrentListingHovered && setCurrentListingHovered(listingId);
            const targetCard = document.getElementById("card-" + listingId);
            targetCard && targetCard.scrollIntoView({ behavior: "smooth"});
          }          
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
          {revenueLtm}
        </Typography>
      </Box>
    );
  }

  return <></>;
};

export default CenterPointer;
